<script setup lang="ts">
import { asText } from '@prismicio/client'
import type { Content } from '@prismicio/client'

const { slice } = defineProps(getSliceComponentProps<Content.FeatureCardsGridSlice>())
</script>

<template>
  <section
    :data-slice-type="slice.slice_type"
    :data-slice-variation="slice.variation"
    class="pa-feature-cards"
  >
    <div class="pa-container">
      <div class="pa-feature-cards__grid">
        <div
          v-for="(card, i) in slice.primary.cards"
          :key="i"
          class="pa-feature-cards__card"
        >
          <h3 class="pa-feature-cards__title">{{ asText(card.title) }}</h3>
          <div class="pa-feature-cards__desc">
            <PrismicRichText :field="card.description" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
